import { useQuery } from '@tanstack/react-query'
import { GETMarketplaceItems } from '../requests'
import { CustomQueryOptions } from '@/common/types_and_interfaces'
import { MarketplaceItemList } from '../marketplace.schema'

export const GET_MARKETPLACE_ITEMS_QUERY_KEY = (
  programId?: number,
  business_type?: string,
  search?: string,
  provider_id?: number,
  affiliation_id?: number,
  perPage: number = 10,
  page: number = 1
) => [
  'marketplaceItems',
  programId,
  business_type,
  search,
  provider_id,
  affiliation_id,
  perPage,
  page,
]

export const useMarketplaceItems = (
  programId?: number,
  business_type?: string,
  search?: string,
  provider_id?: number,
  affiliation_id?: number,
  perPage: number = 10,
  page: number = 1,
  options: CustomQueryOptions<MarketplaceItemList> = {}
) => {
  return useQuery({
    queryKey: GET_MARKETPLACE_ITEMS_QUERY_KEY(
      programId,
      business_type,
      search,
      provider_id,
      affiliation_id,
      perPage,
      page
    ),
    queryFn: () =>
      GETMarketplaceItems(
        programId,
        business_type,
        search,
        provider_id,
        affiliation_id,
        perPage,
        page
      ),
    ...options,
  })
}
